export default function Footer() {
  return (
    <footer id="contacto" className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-20 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-20 mb-20">
          <div className="lg:col-span-4">
            <h3 className="text-6xl font-bold mb-16 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              Marquetería y Vidriería Hollywood
            </h3>
            
            <p className="text-white text-lg leading-relaxed mb-16 max-w-md" style={{ lineHeight: '1.7' }}>
              Especialistas en arte, decoración y trabajo en vidrio. Transformamos tus ideas en 
              obras únicas con dedicación artesanal y atención al detalle.
            </p>
            
            <div className="flex items-center gap-8">
              <a
                href="https://wa.me/573153477916"
                target="_blank"
                rel="noopener noreferrer"
                className="w-16 h-16 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a
                href="mailto:galeriahollywood.0@gmail.com"
                className="w-16 h-16 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 space-y-12">
            <div>
              <h4 className="text-sm font-semibold tracking-widest mb-4 text-white uppercase">UBICACIÓN</h4>
              <p className="text-white text-lg leading-relaxed">
                Carrera 8 # 9 - 32
              </p>
            </div>
            
            <div>
              <h4 className="text-sm font-semibold tracking-widest mb-4 text-white uppercase">TELÉFONO</h4>
              <p className="text-white text-lg">+57 3153477916</p>
            </div>
            
            <div>
              <h4 className="text-sm font-semibold tracking-widest mb-4 text-white uppercase">CORREO</h4>
              <p className="text-white text-lg">galeriahollywood.0@gmail.com</p>
            </div>
          </div>

          <div className="lg:col-span-4 flex justify-end">
            <div className="w-80 h-[450px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/00db3071267c69c51a4cac34e0401a25.jpg"
                alt="Taller"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-white text-base">© 2025 Marquetería y Vidriería Hollywood</p>
          
          <div className="flex items-center gap-10">
            <a href="#" className="text-white text-base hover:text-[#D4856C] transition-colors cursor-pointer">
              Privacidad
            </a>
            <a href="#" className="text-white text-base hover:text-[#D4856C] transition-colors cursor-pointer">
              Términos
            </a>
            <a href="#contacto" className="text-white text-base hover:text-[#D4856C] transition-colors cursor-pointer">
              Contacto
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-white text-base hover:text-[#D4856C] transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
